import React from 'react';
import {
  FaBox,
  FaCheck,
  FaCreditCard,
  FaHome,
  FaMotorcycle,
  FaStore,
  FaTimes,
} from 'react-icons/fa';
import OrderPreparingIcon from './OrderPreparingIcon';
import { ORDER_STEPPER_LABELS, SHOW_ORDER_PROGRESS_STEPPER, getLiveOrderStepperState } from './orderProgressStepperUtils';

const STEP_ICONS = [FaCheck, FaCreditCard, FaStore, OrderPreparingIcon, FaBox, FaMotorcycle, FaHome];
const PREPARING_STEP_INDEX = 3;

/**
 * Horizontal progress: fixed-width node columns with flex gaps so connector
 * spacing is even (Our Menu / timeline-style layout).
 */
function OrderProgressStepper({ status }) {
  if (!SHOW_ORDER_PROGRESS_STEPPER) return null;

  const { activeIndex, cancelled } = getLiveOrderStepperState(status);

  if (cancelled) {
    return (
      <div className="account-orders__stepper-cancelled" role="status">
        <FaTimes aria-hidden className="account-orders__stepper-cancelled-icon" />
        <span>This order was cancelled.</span>
      </div>
    );
  }

  return (
    <div className="account-orders__stepper" aria-label="Order progress">
      <div className="account-orders__stepper-row">
        {ORDER_STEPPER_LABELS.map((label, i) => {
          const done = i < activeIndex;
          const current = i === activeIndex;
          const Icon = STEP_ICONS[i] || FaCheck;
          const nodeClass = [
            'account-orders__step-node',
            done ? 'account-orders__step-node--done' : '',
            current ? 'account-orders__step-node--current' : '',
            !done && !current ? 'account-orders__step-node--upcoming' : '',
          ]
            .filter(Boolean)
            .join(' ');

          return (
            <React.Fragment key={label}>
              {i > 0 ? (
                <div
                  className={`account-orders__step-gap${activeIndex >= i ? ' account-orders__step-gap--done' : ''}`}
                  aria-hidden
                />
              ) : null}
              <div className="account-orders__step-node-wrap">
                <div className={nodeClass}>
                  {done ? (
                    <FaCheck className="account-orders__step-svg" aria-hidden />
                  ) : (
                    <Icon
                      className={
                        i === PREPARING_STEP_INDEX
                          ? 'account-orders__step-svg account-orders__step-svg--preparing'
                          : 'account-orders__step-svg'
                      }
                      aria-hidden
                    />
                  )}
                </div>
                <span
                  className={`account-orders__step-label${current ? ' account-orders__step-label--current' : ''}`}
                >
                  {label}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default OrderProgressStepper;
